import { Link } from 'react-router-dom';
import { ArrowUpRight, PackagePlus } from 'lucide-react';

export default function AddonsSection() {
  return (
    <section className="card p-6">
      <div className="flex items-start gap-3">
        <div className="rounded-lg bg-teal/10 p-2 text-teal">
          <PackagePlus className="h-5 w-5" />
        </div>
        <div className="flex-1">
          <h2 className="text-lg font-semibold text-ink-primary">Add-ons</h2>
          <p className="mt-1 text-sm text-ink-secondary">
            Catalog management stays on the dedicated add-ons screen.
          </p>
          <Link
            to="/addons"
            className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-gold hover:text-gold-light"
          >
            Open Add-ons
            <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
